// Progress curve of the "Final quality checks" step of the building screen (ADR-0179 Update 18, Jonathan 2026-10-28).
// The four build steps fill 0 to FINAL_START percent; this step starts there, climbs steadily to FINAL_CLIMB_TO over its expected duration
// (a little slower than the real median, so most packages finish early), then crawls toward FINAL_CRAWL_TO. Only a released package reaches 100,
// which is the surge at the end. Measured 2026-10-28: the review took a median of 1.7 minutes before the second pass, the second pass adds about 4 to 6.

export const FINAL_START = 70;
export const FINAL_CLIMB_TO = 94;
export const FINAL_CRAWL_TO = 97;
const CRAWL_TAU_SECONDS = 300;

/** Expected length of the final step in seconds, longer for bigger casts (more sheets to read). */
export function finalPhaseSeconds(playerCount: number): number {
  const n = playerCount || 6;
  if (n <= 10) return 420;
  if (n <= 18) return 480;
  if (n <= 28) return 540;
  return 600;
}

/** Displayed percent while the final step is active, given seconds since it started. */
export function finalPhaseProgress(elapsedSeconds: number, durationSeconds: number): number {
  const e = Math.max(0, Number.isFinite(elapsedSeconds) ? elapsedSeconds : 0);
  if (e <= durationSeconds) return FINAL_START + (FINAL_CLIMB_TO - FINAL_START) * (e / durationSeconds);
  return FINAL_CLIMB_TO + (FINAL_CRAWL_TO - FINAL_CLIMB_TO) * (1 - Math.exp(-(e - durationSeconds) / CRAWL_TAU_SECONDS));
}

/** Which of the three sub-steps is active: 0 reading the sheets, 1 cross-checking, 2 applying fixes and the last read-through. */
export function finalStepIndex(elapsedSeconds: number, durationSeconds: number): 0 | 1 | 2 {
  const f = Math.max(0, elapsedSeconds) / durationSeconds;
  return f < 0.25 ? 0 : f < 0.7 ? 1 : 2;
}
